import React from "react";
import { Star } from "lucide-react";

export default function Rating({ rating = 0, count, size = 14, showCount = true, className = "" }) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return (
    <div className={`flex items-center gap-1 ${className}`} data-testid="rating">
      <div className="flex items-center">
        {Array.from({ length: 5 }).map((_, i) => {
          const active = i < full || (i === full && half);
          return (
            <Star
              key={i}
              size={size}
              className={active ? "fill-gold text-gold" : "text-muted-foreground/40"}
              strokeWidth={active ? 0 : 1.5}
            />
          );
        })}
      </div>
      {showCount && (
        <span className="text-xs text-muted-foreground">
          {rating ? rating.toFixed(1) : ""} {count != null ? `(${count})` : ""}
        </span>
      )}
    </div>
  );
}
